export const mainArray = ( {dropDowns}) => [
    {
        id: "locationId",
        name: "locationId",
        type: "text",
        label: "Location Id",
        options: dropDowns?.locations || [],
      tag: "select",
    },
    {
      id: "orderDate",
      name: "orderDate",
      type: "datetime",
      label: "Order Date",

    },
  ];
  export const partnerArray = ( {}) => [
    {
      id: "shiptoId",
      name: "shiptoId",
      label: "Shipto",
    },
    {
      id: "soldtoId",
      name: "soldtoId",
      label: "Soldto",
    },
  ];